
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menuItem/create",
      function () {
        return require("private-next-pages/menuItem/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menuItem/create"])
      });
    }
  